import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import DeleteIcon from 'ui-library/icons/DeleteIcon';
import {immutableRemoveAt, immutableReplace} from 'util/ImmutableListUtil';
import {JSONArray} from 'util/Types';

import {StepConfigUISchema} from '../StepConfigEditorTypes';
import StepConfigEditorRouter from './StepConfigEditorRouter';

interface ArrayEditorProps {
  config: JSONArray;
  configShape: GetPipelineConfigSpecType<'array'>;
  dataTestAttrs: Pick<DataTestAttrs, 'key'>;
  onChangeConfig: (config: JSONArray) => void;
  uiSchema: StepConfigUISchema;
  disabled?: boolean;
}

export default function ArrayEditor({
  config,
  configShape,
  dataTestAttrs,
  onChangeConfig,
  uiSchema,
  disabled,
}: ArrayEditorProps): JSX.Element {
  const isDeleteDisabled = config.length <= (configShape.minItems ?? 0);
  return (
    <>
      {config.map((element, index) => (
        <StepConfigEditorRouter
          key={index}
          config={element}
          configShape={configShape.elementSpec}
          dataTestAttrs={{key: dataTestAttrs.key, index: `${index}`}}
          disabled={disabled}
          uiSchema={uiSchema}
          onChangeConfig={(newValue) => {
            onChangeConfig(immutableReplace(config, index, newValue));
          }}
          trashIcon={
            disabled ? undefined : (
              <Tooltip
                isDisabled={!isDeleteDisabled}
                text={`Must have at least ${configShape.minItems ?? 0} ${pluralize(
                  configShape.minItems ?? 0,
                  'item',
                  'items'
                )}`}
              >
                <DeleteIcon
                  icon="trash-can"
                  disabled={isDeleteDisabled}
                  onClick={() => {
                    onChangeConfig(immutableRemoveAt(config, index));
                  }}
                />
              </Tooltip>
            )
          }
        />
      ))}
    </>
  );
}
